import React from 'react'

import cx from 'classnames'

import { Icon } from '@driftt/tide-icons'

import styles from './styles.module.css'

const DeletedComment: React.FC = () => {
  return (
    <div className={cx(styles.commentBody, styles.deletedComment)}>
      <div className={styles.deletedCommentIcon}>
        <Icon name="trash" width="12px" height="14px" />
      </div>
      <div className={styles.commentContent}>This comment was deleted.</div>
    </div>
  )
}

export default DeletedComment
